import ArticleHero from './ArticleHero';

export { type ArticleHeroProps } from './ArticleHero';
export default ArticleHero;
